import { styled } from '@mui/material';

export const Form = styled('form')(({ theme }) => ({
  color: theme.palette.grey[100],
}));
